import "./App.css";
import React, { useEffect, useState } from "react";
import StockChart from "./StockChart";
import * as d3 from "d3";

//import dummy data from JSON file
//const chartData = require('./dummyData.json')

const chartData = d3.timeDay.range(
  new Date(2015, 0, 1),
  new Date(2015, 3, 7),
  1
);
const lineData = require("./lineData.json");
const barData = require("./deltaData.json");

// console.log(lineData)
//convert date and time strings into Date objects
const dateFormat = d3.timeParse("%m/%d/%Y %I:%M:%S%p");
// lineData.forEach(d=>d.datetime = dateFormat(`${d.date} ${d.time}`))

const dimensions = {
  width: 900,
  height: 900,
  margin: { top: 25, right: 55, bottom: 25, left: 35 },
  chartHeight: 300,
  matchedDeltaHeight: 300,
  focusHeight: 70,
};

function App() {
  return (
    <div className="App">
      <StockChart
        //data={chartData.sort((a,b)=>a.datetime.getTime() - b.datetime.getTime())}
        data={lineData
          .map((d) => {
            return {
              datetime: dateFormat(`${d.date} ${d.time}`),
              spread: d.min,
              total_matched_delta: Math.floor(Math.random() * 400 + 400),
            };
          })
          .sort((a, b) => a.datetime.getTime() - b.datetime.getTime())}
        deltaData={barData
          .map((d) => {
            return {
              datetime: dateFormat(`${d.date} ${d.time}`),
              total: d.total,
              change: d.change,
            };
          })
          .sort((a, b) => a.datetime.getTime() - b.datetime.getTime())}
        dimensions={dimensions}
      ></StockChart>
    </div>
  );
}

export default App;
